export const CompanyConstants = {
    NATSHOOT: '32D79957-A1C3-48D3-80C4-A5F2435C58A4'
}